import {
	BLUE_GRAY_COLORS,
	BRAND_COLORS,
	ERROR_COLORS,
	GRAY_COLORS,
	SUCCESS_COLORS,
	WARNING_COLORS
} from '../globalTheme';

export const theme = {
	button: {
		size: {
			small: {
				width: '106px',
				height: '36px',
				padding: '8px 14px',
				fontSize: '14px'
			},
			medium: {
				width: '110px',
				height: '40px',
				padding: '10px 16px',
				fontSize: '16px'
			},
			large: {
				width: '125px',
				height: '44px',
				padding: '10px 18px',
				fontSize: '16px'
			},
			auto: {
				width: 'auto',
				height: '40px',
				padding: '10px 16px',
				fontSize: '16px'
			},
			full: {
				width: '100%',
				height: '40px',
				padding: '10px 16px',
				fontSize: '16px'
			}
		},
		iconExtraWidth: '28px',
		color: {
			primary: { backgroundColor: BRAND_COLORS.brand600, color: 'white' },
			success: { backgroundColor: SUCCESS_COLORS.success600, color: 'white' },
			secondary: {
				backgroundColor: BRAND_COLORS.brand50,
				color: BRAND_COLORS.brand700
			},
			blueGray: {
				backgroundColor: BLUE_GRAY_COLORS.blueGray600,
				color: 'white'
			},
			error: { backgroundColor: ERROR_COLORS.error600, color: 'white' },
			destroy_secondary: {
				backgroundColor: ERROR_COLORS.error50,
				color: ERROR_COLORS.error700
			},
			gray: {
				backgroundColor: GRAY_COLORS.gray200,
				color: GRAY_COLORS.gray600
			},
			warning: {
				backgroundColor: WARNING_COLORS.warning50,
				color: WARNING_COLORS.warning700
			},
			white: { backgroundColor: 'white', color: GRAY_COLORS.gray900 }
		}
	},
	textButton: {
		color: {
			primary: { backgroundColor: 'transparent', color: BRAND_COLORS.brand600 },
			success: {
				backgroundColor: 'transparent',
				color: SUCCESS_COLORS.success600
			},
			blueGray: {
				backgroundColor: 'transparent',
				color: BLUE_GRAY_COLORS.blueGray600
			},
			secondary: {
				backgroundColor: 'transparent',
				color: BRAND_COLORS.brand700
			},
			error: { backgroundColor: 'transparent', color: ERROR_COLORS.error600 },
			destroy_secondary: {
				backgroundColor: 'transparent',
				color: ERROR_COLORS.error700
			},
			gray: { backgroundColor: 'transparent', color: GRAY_COLORS.gray600 },
			warning: {
				backgroundColor: 'transparent',
				color: WARNING_COLORS.warning700
			},
			white: { backgroundColor: 'transparent', color: GRAY_COLORS.gray900 }
		}
	}
};
export type Theme = typeof theme;
export type ButtonSize = keyof Theme['button']['size'];
export type ButtonColor = keyof Theme['button']['color'];
